/**
*
* Plugins
*
*/

import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PluginDetails from 'Workspace/Plugins/components/PluginDetails';
import PluginsPage from 'Workspace/Plugins/components/PluginsPage';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';

const Plugins = () => (
  <React.Fragment>
    <Switch>
      <Route path="/plugins/:pluginId" component={PluginDetails} />
      <Route exact path="/plugins" component={PluginsPage} />
      <Redirect to="/plugins" />
    </Switch>
    <HelpMenu />
  </React.Fragment>
);

export default Plugins;
